import Vue from "vue";
import moment from "moment";

Vue.filter("formatLLL", (iso) => iso
  ? moment(String(iso)).format("LLL")
  : "...");

Vue.filter("formatCal", (iso) => iso
  ? moment(String(iso)).calendar().toLowerCase()
  : "...");

Vue.filter("formatFn", (iso) => iso
  ? moment(String(iso)).fromNow()
  : "...");

Vue.filter("formatBsSerial", (serial) => serial
  ? serial.
    toUpperCase().
    replace(/^S?\/?N?:? ?0+/, "").
    replace(/(-| ).*/, "")
  : null);

Vue.filter("formatUSBSerial", (serial) => serial
  ? serial.
    toUpperCase().
    replace(/^S?\/?N?:? ?/, "")
  : null);

Vue.filter("formatLNASerial", (serial) => serial
  ? serial.
    toUpperCase().
    replace(/^S?\/?N?:? ?/, "")
  : null);

Vue.filter("formatRouterSerial", (serial) => serial
  ? serial.
    toUpperCase()
  : null);

Vue.filter("formatInstallation", (installation) => {
  switch (installation) {
    case 0:
      return "indoor without cabinet";
      break;
    case 1:
      return "outdoor with cabinet";
      break;
    case 2:
      return "indoor with cabinet";
      break;
    case 3:
      return "outdoor without cabinet";
      break;
  }
});

Vue.filter("formatIId", (id) => {
  if (id === 0) {
    return "< ID >";
  }
  const id36 = id.toString(36);
  let padded = "0000";
  padded = padded + id36;
  padded = padded.substr(-4).toUpperCase();
  return `THX-MT-I-${padded}`;
});

Vue.filter("formatJId", (id) => {
  if (id === 0) {
    return "< ID >";
  }
  const id36 = id.toString(36);
  let padded = "0000";
  padded = padded + id36;
  padded = padded.substr(-4).toUpperCase();
  return `THX-MT-J-${padded}`;
});

Vue.filter("formatSId", (id, region) => {
  if (id === 0) {
    return "< ID >";
  }
  const id36 = id.toString(36);
  let padded = "000";
  padded = padded + id36;
  padded = padded.substr(-3).toUpperCase();
  if (region == 'AU') region = 'AUS';
  return `THX-${region}-${padded}`;
});



// WEBPACK FOOTER //
// ./src/filters/filters.js